/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Flex } from '@radix-ui/themes';

import Text from 'solis/react/primitive/text';

import Countdown from 'solis/claude/element/countdown';
import Swatch from 'solis/claude/element/user/swatch';


const getEvents = ({ zoneTimeline, currentDate, previousDate }) =>
{
  return zoneTimeline.getFutureEvents(previousDate ?? currentDate);
};


const Label = ({ currentDate, previousDate }) =>
{
  if (previousDate == null)
  {
    return 'now';
  }

  return <>in <Countdown date = {currentDate} /></>;
}

const Component = (props) =>
(
  <Flex align = 'center' gap = '2'>

    <Swatch />

    <Text.Note>
      <Label {...props} />
    </Text.Note>

  </Flex>
);


export default (props) =>
{
  return getEvents(props).length > 0 ? <Component {...props} /> : null;
};
